import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';
import useSessions from '../../../core/hooks/use-sessions';

import Filters from './components/filters';
import SessionsTable from './components/sessions-table';

import * as S from './styles';

const DEBOUNCE_TIME = 700;

function Sessions() {
  const [attributes, setAttributes] = useState({});

  const {
    data: {
      testSessionList = [],
    },
    loading,
  } = useSessions(attributes);

  const handleStatusFilter = useCallback((status) => setAttributes({ ...attributes, status }), [attributes, setAttributes]);
  const handleWorkspaceFilter = _.debounce((company) => setAttributes({ ...attributes, company }), DEBOUNCE_TIME);
  const handleProjectFilter = _.debounce((project) => setAttributes({ ...attributes, project }), DEBOUNCE_TIME);

  return (
    <S.Container>
      <S.Header>
        <S.Title>
          Sessions
        </S.Title>
      </S.Header>

      <Filters
        onStatusSelected={handleStatusFilter}
        onWorkspaceSearch={handleWorkspaceFilter}
        onProjectSearch={handleProjectFilter}
      />

      {loading && (
        <S.Centered>
          <S.Loader size="big">Loading sessions</S.Loader>
        </S.Centered>
      )}

      {testSessionList.length === 0 && !loading && (
        <S.Centered>
          <S.Text>No sessions to display.</S.Text>
        </S.Centered>
      )}

      {testSessionList.length > 0 && (
        <SessionsTable data={testSessionList} />
      )}
    </S.Container>
  );
}

export default withDashboardSidebar(Sessions);
